// 환경별 설정 - 환경변수 우선 사용
const getConfig = () => {
  return {
    // API 엔드포인트 - 환경변수에서 가져오거나 기본값 사용
    API_ENDPOINT: process.env.REACT_APP_API_BASE_URL || 'https://your-api-endpoint.com/log',
    
    // 각 step별 리다이렉트 URL 설정 - 환경변수에서 가져오거나 기본값 사용
    REDIRECT_URLS: {
      step1: process.env.REACT_APP_REDIRECT_STEP1 || 'https://example.com',
      step2: process.env.REACT_APP_REDIRECT_STEP2 || 'https://example.com'
    },
    
    // 기본 리다이렉트 URL - 환경변수에서 가져오거나 기본값 사용
    DEFAULT_REDIRECT_URL: process.env.REACT_APP_DEFAULT_REDIRECT_URL || 'https://example.com',
    
    // 로딩 화면 표시 임계값 (밀리초)
    LOADING_THRESHOLD: 500,
    
    // 개발 모드 (콘솔 로그 출력 여부) - 환경변수에서 가져오거나 기본값 사용
    DEBUG_MODE: process.env.REACT_APP_DEBUG_MODE !== 'false'
  };
};

// 설정 파일
export const CONFIG = getConfig();